import { makeStyles } from '@material-ui/core/styles';
import { themeColor } from '../mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  mainErrorMsg: {
    margin: 0,
  },
  bottomErrorMsg: {
    margin: 0,
    color: themeColor.defaultTextColor,
  },
}));
